import React from 'react'
import classNames from 'classnames'
import { GatsbyImage, StaticImage } from 'gatsby-plugin-image'
import {
  ArticleContent,
  ArticleSource,
  AuthorImage,
  Breadcrumb,
  ShowHeroBox,
  TableOfContent,
} from '../../../../common/components'
import ArticleLanguageLinks from '../../../../common/components/ArticleLanguageLinks'
import { Col } from '../../../../common/lib'
import styles from '../../../../common/scss/content.module.scss'
import { speakAbleData } from '../../../../common/utils/getSpeakAbleData'
import replaceText from '../../../../common/utils/replaceText'
import { Link } from 'gatsby'

const ArticleContentSection = ({
  faqs,
  article,
  location,
  pathname,
  updatedAt,
  lastUpdatedRef,
  tokens
}) => {
  return (
    <Col
      md={8}
      lg={6}
      className="content articleScroll article-content pb-md-4"
      style={{
        direction: article.language === 'ar' ? 'rtl' : 'ltr',
        textAlign: article.language === 'ar' ? 'right' : 'left',
      }}
    >
      <h1 id="article-title">{replaceText(tokens, article.title)}</h1>
      <Breadcrumb article={article} site="Psychometric Success" tokens={tokens} />
      <div
        ref={lastUpdatedRef}
        className="d-flex justify-content-between align-items-center"
      >
        <p className="my-3 p-0" style={{ fontSize: '0.8em' }}>
          Updated{' '}
          <span
            {...{
              itemProp: 'dateModified',
              content: article._updatedAt,
            }}
          >
            {updatedAt}
          </span>
        </p>
        <div
          className={classNames(
            styles.flexCenter,
            'author',
            article.author && 'pb-2',
            'me-2',
          )}
        >
          {
            article.author ?
              <>
                <span
                  className={`pe-2 ${styles.writtenBy}`}
                  style={{ fontSize: '0.8em', textAlign: 'right' }}
                >
                  Written by{' '}
                  <Link
                    className="orange-link"
                    to={`/team/${article.author.name
                      .toLowerCase()
                      .split(' ')
                      .join('-')}`}
                  >
                    {article.author.name}
                  </Link>
                </span>
                <AuthorImage article={article} />
              </> :
              <>
                <span
                  className={`pe-2 ${styles.writtenBy}`}
                  style={{ fontSize: '0.8em', textAlign: 'right' }}
                >
                  Written by{' '}
                  <Link
                    className="orange-link"
                    to={`/team/edward-mellett`}
                  >
                    Edward Mellett
                  </Link>
                </span>
                <Link
                  to={`/team/edward-mellett`}
                >
                  <StaticImage
                    src="https://www.datocms-assets.com/7756/1539683693-edpice.png?auto=compress%2C%20format%2C%20enhance%2Cformat&facepad=3&fit=facearea&h=50&w=50"
                    alt="Edward Melett"
                  />
                </Link>
              </>
          }
        </div>
      </div>

      <ShowHeroBox article={article} location={location} />
      <div className="d-sm-block d-md-block d-lg-none">
        <TableOfContent data={article.modularContent} faqs={faqs} tokens={tokens} />
      </div>
      <article className="mediavineAdsInContent">
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: `${JSON.stringify(speakAbleData(article, location))}`,
          }}
        />
        <ArticleContent
          content={article.modularContent}
          article={article}
          pathname={pathname}
          count={{ val: 0 }}
          tokens={tokens}
        />
        <ArticleLanguageLinks article={article} />
      </article>
      {article.sources.length > 0 && (
        <ArticleSource sources={article.sources} />
      )}
      <ShowHeroBox article={article} location={location} />
    </Col>
  )
}

export default ArticleContentSection
